// extracted by mini-css-extract-plugin
export var measureBox = "_cw-0";